module.exports = __webpack_public_path__ + "img/db-banner-img.c545b98b.svg";